module.exports = __webpack_public_path__ + "img/logo_dragoon_soft.4adad715.png";